import { TableColumn } from "../../types";
import { InternalLink } from "../../components/InternalLink";
import { useAppSelector } from "../../../../store/hooks";
import { selectOrg } from "../../../../store/contextSlice";

const userNameDescriptionDefault = { id: "email", label: "Email" };
export function UserNameDescriptionColumn<TData extends { email: string; name: string; kind: string }>(
  column: Partial<TableColumn<TData>> = userNameDescriptionDefault,
  opts?: { shouldForceTargetBlank?: (item: TData) => boolean },
) {
  const preset: TableColumn<TData> = {
    ...userNameDescriptionDefault,
    enableResize: true,
    enableSort: true,
    size: 200,
    cell: (p) => {
      const org = useAppSelector(selectOrg);

      const item = p.row.original;
      let link = `/console/org/${org}/${item.kind}/${item.email}`;

      const forceTargetBlank = opts?.shouldForceTargetBlank?.(item);

      return (
        <div className="flex flex-col justify-center" style={{ height: 56 }}>
          <InternalLink label={item.email} to={link} forceTargetBlank={forceTargetBlank} />
          <span className="text-sm description">{item.name}</span>
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
